import React from 'react';

import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'constants/routes';
import { ButtonVariants } from 'constants/shared/button';
import { CompanyInvestor } from 'interfaces';
import { Button } from 'shared-components';
import { TableData, TableRow } from 'shared-components/table';

interface Props {
  investor: CompanyInvestor;
}

const EntityInvestorsItem = ({ investor }: Props) => {
  const navigate = useNavigate();
  const handleNavigateToInvestorProfile = () =>
    navigate(`${ROUTES.admin}${ROUTES.investor}`.replace(':id', investor.id.toString()));

  return (
    <TableRow>
      <TableData>
        <Button
          variant={ButtonVariants.SECONDARY}
          className='w-[120px]'
          disabled={investor.status !== 'registered'}
          onClick={() => handleNavigateToInvestorProfile()}
        >
          View
        </Button>
      </TableData>
      <TableData>{`${investor.firstName} ${investor.lastName}`}</TableData>
      <TableData>{investor.email}</TableData>
      <TableData>{investor.status}</TableData>
      <TableData>{investor.position}</TableData>
    </TableRow>
  );
};

export default EntityInvestorsItem;
